export const headName = 'お客さま情報について '
export const head2Name = '匿名にて弊社への連絡をご希望される場合には右のボックスをチェックしてください'
export const labels1 = '【ご契約者さま／ご契約がないお問い合わせ者さま　情報】'
export const name = 'お名前 '
export const furigana = 'フリガナ'
export const birthday = '生年月日'
export const contactAddress = 'ご連絡先住所'
export const phoneNo = '電話番号'
export const emails = 'E-mail'
export const ourContract = '弊社のご契約　'
export const labels2 = '【お問い合わせいただいている方とご契約者さまが異なる場合】'
export const personName = 'お問い合わせいただいている方のお名前'
export const furiganaName = 'お問い合わせいただいている方のフリガナ'
export const personPhoneNo = 'お問い合わせいただいている方の電話番号'
export const personEmail = 'お問い合わせいただいている方のE-mail'
export const labels3 = '※契約者ご本人さま以外にはご回答できない内容もございます。'
export const contentOfInquery = 'お問い合わせ内容'
export const checkbox1 = '証券番号が不明の場合、左ボックスにチェックしてください。'
export const checkbox2 = '弊社にご契約がない場合、左ボックスにチェックしてください。'
export const subscriber = 'ご契約者さまとの続柄'
export const pageTitle = 'お問い合わせフォーム | メットライフ生命'
